import { useTranslation } from "react-i18next";

import { ColumnFiltersState } from "@tanstack/react-table";

import { FilterHeader } from "./FilterHeader";

const CATEGORIES = [
    "build",
    "device",
    "file",
    "gateway",
    "group",
    "license",
    "product",
    "provisioning",
    "user",
    "workspace",
] as const;

type Props = {
    columnFilters: ColumnFiltersState;
    setColumnFilters: React.Dispatch<React.SetStateAction<ColumnFiltersState>>;
};
export const EventCategoryHeader = ({ columnFilters, setColumnFilters }: Props) => {
    const { t } = useTranslation("common");
    const current = (columnFilters.find((f) => f.id === "category")?.value as string[] | undefined) ?? [];

    return (
        <FilterHeader
            title={t("table.filter.category")}
            sortDisabled
            options={CATEGORIES.map((category) => ({
                key: category,
                label: t(`table.filter.categoryOptions.${category}`),
            }))}
            initialValues={Object.fromEntries(CATEGORIES.map((category) => [category, current.includes(category)]))}
            onSubmit={(values) => {
                const value = Object.keys(values).filter((k) => values[k]);
                setColumnFilters((prev) => {
                    const rest = prev.filter((f) => f.id !== "category");
                    return value.length ? [{ id: "category", value }, ...rest] : rest;
                });
            }}
        />
    );
};
